import { render, staticRenderFns } from "./XReportDetails.vue?vue&type=template&id=7ba2b50d&"
import script from "./XReportDetails.vue?vue&type=script&lang=js&"
export * from "./XReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports